import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import translate from '../../../config/translations/translate';
import ReviewLeaderboardStoreView from './ReviewLeaderboardStoreView';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { setSelectedStoreForReviewLeaderboard } from '../../../commons/components/application/applicationActions';
import MobileScreenUnavailableMessage from '../../../commons/components/application/MobileScreenUnavailableMessage';
import { useNotificationTracking } from '../../../commons/utils/useNotificationTracking';
import withEventTracking from '../../../config/withEventTracking';

const ReviewLeaderboardStoreDetailsWrapper = ({t, storeId, trackEvent}) => {
    const selectedCompany = useSelector(state => state.application.selectedCompany);
    const availableStores = useSelector(state => state.application.availableStores);
    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);  
    const [isMobileModalOpen, setIsMobileModalOpen] = useState(window.innerWidth < 900);
    useEffect(() => {
        const filteredStores = availableStores.filter(store => store.companyId === selectedCompany.id);
        setStores(filteredStores);
        setSelectedStore(filteredStores.find(store => store.id === parseInt(storeId)));
    
    }, [availableStores, selectedCompany])

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (windowWidth < 900) {
            setIsMobileModalOpen(true);
        } else {
            setIsMobileModalOpen(false);
        }
    }, [windowWidth]);

    useNotificationTracking(trackEvent, 'review_leaderboard_store_details');

    const handleStoreChange = (event) => {
        const storeId = parseInt(event.target.value);
        const store = stores.find(store => store.id === parseInt(storeId));
        setSelectedStore(store);
        dispatch(setSelectedStoreForReviewLeaderboard(store));
        history.push(`/review-leaderboard/${store.id}`);
    };
    
    return (
        <>
            <MobileScreenUnavailableMessage isOpen={isMobileModalOpen} />
            <ReviewLeaderboardStoreView
                storeId={storeId}
                storeName={selectedStore && selectedStore.name}
                t={t}
                stores={stores}
                selectedStore={selectedStore}
                showStoreSelector={true}
                handleStoreChange={handleStoreChange}
            />
        </>
    );
    
};

export default withEventTracking(translate(ReviewLeaderboardStoreDetailsWrapper));
